import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiScissors, FiInstagram, FiFacebook, FiTwitter } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-12 pb-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <SafeIcon icon={FiScissors} className="text-2xl text-indigo-400" />
              <span className="font-bold text-xl tracking-tight">InfoKonveksi</span>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Portal informasi terpercaya seputar dunia konveksi, tekstil, dan fashion di Indonesia. Kami menyajikan panduan, tips, dan rekomendasi vendor terbaik.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4 border-b border-gray-700 pb-2 inline-block">Kategori Populer</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#" className="hover:text-indigo-400 transition-colors">Panduan Bahan</a></li>
              <li><a href="#" className="hover:text-indigo-400 transition-colors">Tips Bisnis</a></li>
              <li><a href="#" className="hover:text-indigo-400 transition-colors">Rekomendasi Vendor</a></li>
              <li><a href="#" className="hover:text-indigo-400 transition-colors">Tren Seragam</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 border-b border-gray-700 pb-2 inline-block">Ikuti Kami</h3>
            <div className="flex space-x-4">
              <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-indigo-600 transition-colors">
                <SafeIcon icon={FiInstagram} className="text-xl" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-indigo-600 transition-colors">
                <SafeIcon icon={FiFacebook} className="text-xl" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-indigo-600 transition-colors">
                <SafeIcon icon={FiTwitter} className="text-xl" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 text-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} InfoKonveksi Blog. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;